export const selectIsLoading = state => {
    return state.buckets.isLoading;
};

export const selectPage = state => {
    return state.buckets.page;
};

export const selectSortColumn = state => {
    return state.buckets.sortColumn;
};

export const selectSelectedBucket = state => {
    return state.buckets.selectedBucket;
};

export const selectBucketsDetail = state => {
    return state.buckets.bucketsDetail;
};

export const selectAccessibleBuckets = state => {
    return state.buckets.accessibleBuckets;
};

export const selectAvailableLocations = state => {
    return state.buckets.availableLocations;
};

export const selectLinkedLocations = state => {
    return state.buckets.linkedLocations;
};

export const selectBucketNoData = state => {
    return state.buckets.bucketNoData;
};

export const selectUsers = state => {
    return state.buckets.users;
};

export const selectAssignedUsers = state => {
    return state.buckets.assignedUsers;
};

export const selectIsUsersLoading = state => {
    return state.buckets.isUsersLoading;
};
